export default __webpack_public_path__ + "290fb56cbbbf30031f9f6c8b54c4ae82.svg";